<template>
    <div class="animated fadeIn">
        <div class="card" style="margin:0px 15px 10px 15px">
            <div class="row" style="padding: 20px;background-color:#fff">
                <div class="col-md-8">
                    <p style="font-size: 16px;">This pages shows the list of all verified customers</p>
                </div>
                <div class="col-md-4">
                    <p class="text-right">
                        <b-link to="#" v-show="!loading" @click="fetchData(1)">
                            <span class="fa fa-refresh"></span> Refresh Records
                        </b-link>
                    </p>
                </div>
            </div>
        </div>
        <b-card header="Active Customers">
            <b-card>
                <p v-if="loading" style="text-align: center;padding: 20px">
                    <span style="font-size: 25px;">
                        <i class="fa fa-spinner fa-spin"></i> Loading data ...
                    </span>
                </p>
                <div v-else>
                    <div v-if="tableData.length < 1">
                        <p style="font-size: 15px;" class="text-center">
                            <i>There are no verified customers at this moment.</i>
                        </p>
                    </div>
                    <div v-else>
                        <v-client-table :data="tableData" :columns="columns" :options="options">
                            <b-link slot="actions" slot-scope="props" to="#" @click="viewUser(props.row.actions)"><i class="fa fa-eye"> </i> View Profile</b-link>
                            <div slot="status">
                                <b-badge variant="success" pill>Verified</b-badge>
                            </div>
                        </v-client-table>
                    </div>
                </div>
            </b-card>
            <b-pagination
              align="left"
              v-model="response.current_page"
              :total-rows="response.total"
              :per-page="response.per_page"
              @change="getPaginated"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
            ></b-pagination>
        </b-card>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import {allUsers} from '@/services/userService';

export default {
    name: 'activecustomers',
    data() {
        return {
            columns: ['id', 'first_name', 'last_name', 'work_email', 'gender', 'status', 'date', 'actions'],
            tableData: [],
            role: '',
            per_page: 50,
            last_page: 0,
            total_pages: 0,
            current_page: 0,
            pageNumbers: [],
            loading: false,
            options: {
                headings: {
                    id: 'S/N',
                    first_name: 'First Name',
                    last_name: 'Last Name',
                    work_email: 'Work Email',
                    gender: 'Gender',
                    status: 'Status',
                    date: 'Reg Date',
                    actions: 'View Details'
                },
                sortable: ['first_name', 'last_name'],
                filterable: ['first_name', 'last_name', 'email', 'gender'],
                perPage: 50,
            },
            response: {}
        }
    },
    computed: {
        ...mapState([
            'roles'
        ])
    },
    mounted() {
        this.role = this.roles[0].name;
        this.fetchData(1);
    },
    methods: {
        async fetchData(page_number) {
            this.loading = true;
            try {
                const { data } = await allUsers(page_number);
                const datas = data.datas;
                this.response = datas;
                this.tableData = [];
                const users = datas.data.filter(customers => parseInt(customers.is_active) === 1 && customers.roles[0].name === "customer");
                const active_customers = users.map(customer => customer.customer);
                this.setData(datas);
                active_customers.reverse().map((customer, index) => {
                    this.tableData.push({
                        id: ++index,
                        first_name: customer.first_name,
                        last_name: customer.last_name,
                        work_email: customer.work_email,
                        gender: customer.gender,
                        status: '',
                        date: customer.created_at,
                        actions: customer.id
                    });
                });
            }
            catch(error) {
                console.log(error);
            }
            finally {
                this.loading = false;
            }
        },
        getPaginated(page_number) {
            this.fetchData(page_number);
        },
        setData(data) {
            let total_pages, last_page, current_page;
            let page_numbers = [];

            if(data) {
                total_pages = data.total;
                last_page = data.last_page;
                current_page = data.current_page;
            }
            else {
                total_pages = 0;
                last_page = 0;
                current_page = 0;
            }

            for (let i = 1; i <= Math.ceil(total_pages / data.per_page); i++) {
                page_numbers.push(i);
            }

            this.current_page = current_page;
            this.total_pages = total_pages;
            this.last_page = last_page;
            this.pageNumbers = page_numbers;
        },
        viewUser(id) {
            this.$router.push(`/customers/${id}`);
        }
    }
}
</script>
<style scoped>
    .pagination {
        margin-top: 25px;
    }

    .pagination span {
        cursor: pointer;
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        border: 1px solid #ddd;
    }

    .pagination span.active {
        background-color: #15974b;
        color: white;
        border: 1px solid #15974b;
    }
</style>
